import { useSelector } from 'react-redux';

import type { RootState } from 'reducers/types';
import { getCurrency, getSchedule } from 'selectors';
import { useTranslations } from 'utils';
import { formatAmount } from 'utils/money';

function useRecurringOfferPrice(value: number, currencyId: string) {
  const i18n = useTranslations();
  const currency = useSelector((state: RootState) =>
    getCurrency(state, currencyId),
  );
  const schedule = useSelector(getSchedule);

  const amount = formatAmount(value, currency);

  const payButtonLabel =
    schedule === 'pay_now'
      ? i18n.t('cardPayment.pay', {
          amount,
        })
      : i18n.t('cardPayment.createPlan');

  return { payButtonLabel, currencyCode: currency.code };
}

export { useRecurringOfferPrice };
